export const FETCH_CATEGORY_MAPPING = "FETCH_CATEGORY_MAPPING";
export const FETCH_CATEGORY_MAPPING_SUCCESS = "FETCH_CATEGORY_MAPPING_SUCCESS";
export const FETCH_CATEGORY_MAPPING_FAILURE = "FETCH_CATEGORY_MAPPING_FAILURE";

export const FETCH_CATEGORY_MAPPING_LIST = "FETCH_CATEGORY_MAPPING_LIST";
export const FETCH_CATEGORY_MAPPING_LIST_SUCCESS = "FETCH_CATEGORY_MAPPING_LIST_SUCCESS";
export const FETCH_CATEGORY_MAPPING_LIST_FAILURE = "FETCH_CATEGORY_MAPPING_LIST_FAILURE";

export const SAVE_CATEGROY_MAPPING_REQUEST = "SAVE_CATEGORY_MAPPING_REQUEST";
export const SAVE_CATEGORY_MAPPING_SUCCESS = "SAVE_CATEGORY_MAPPING_SUCCESS";
export const SAVE_CATEGORY_MAPPING_FAILURE = "SAVE_CATEGORY_MAPPING_FAILURE";
